export default __webpack_public_path__ + "static/media/live_schedule.1568e767.png";